module.exports = __webpack_public_path__ + "static/media/bbc1_cover.5e96cd7a.png";